import { cn } from "@/lib/utils";
import type { Product } from "@/types/models";

export interface ProductThumbnailProps {
  product: Product;
  className?: string;
}

export function ProductThumbnail({ product, className }: ProductThumbnailProps) {
  const image = product.images[0];
  const src = image?.thumbnailUrl ?? image?.url ?? null;

  if (!src) return null;

  return (
    <img
      src={src}
      alt={product.name}
      className={cn(
        "size-10 shrink-0 object-cover border border-primary-200 dark:border-primary-800",
        className
      )}
    />
  );
}
